// extracted by mini-css-extract-plugin
var _1 = "ra-cms-no-margin-bottom";
var _2 = "ra-cms-no-margin-top";
export { _1 as "cmsNoMarginBottom", _2 as "cmsNoMarginTop" }
